import React from "react";
import { Box, Button } from "@mui/material";
import PropTypes from "prop-types";
import MDButton from "../../../../../components/MDButton";
import MDBox from "../../../../../components/MDBox";

const FooterActions = ({
                           onViewOutputs,
                           onRevertAll,
                           onLocalAll,
                           onValidate,
                           onClose,
                           sx = {},
                       }) => {
    return (
        <MDBox
            sx={{
                display: "flex",
                justifyContent: "right",
                gap: 2,
                py: 2,
                borderTop: "1px solid #d3e3fd",
                bgcolor: "#fff",
                borderRadius: "0 0 16px 16px",
                ...sx,
            }}
        >
            <MDButton
                onClick={onRevertAll}
                variant="gradient"  color="info"
                sx={{ minWidth: 140, borderRadius: 3}}
            >
                Revert All
            </MDButton>
            {/*<MDButton*/}
            {/*    onClick={onLocalAll}*/}
            {/*    variant="gradient"  color="info"*/}
            {/*    sx={{ minWidth: 140, borderRadius: 3, marginRight: 3 }}*/}
            {/*>*/}
            {/*    Local All*/}
            {/*</MDButton>*/}
            <MDButton
                onClick={onValidate}
                variant="gradient"  color="info"
                sx={{ minWidth: 140, borderRadius: 3, marginRight: 3 }}
            >
                Validate
            </MDButton>
            {/*<MDButton*/}
            {/*    onClick={onClose}*/}
            {/*    variant="gradient"  color="info"*/}
            {/*    sx={{ minWidth: 140, borderRadius: 3, marginRight: 3 }}*/}
            {/*>*/}
            {/*    Close*/}
            {/*</MDButton>*/}
        </MDBox>
    );
};

FooterActions.propTypes = {
    onViewOutputs: PropTypes.func,
    onRevertAll: PropTypes.func,
    onLocalAll: PropTypes.func,
    onValidate: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    sx: PropTypes.object, // optional if you're passing in styles via sx
};


export default FooterActions;
